import type { BudgetImportPreview, BudgetImportRequest, BudgetImportResult } from "../api/adapters";
import { httpClient } from "../../../lib/http/axios";
import type { ApiEnvelope } from "../../../lib/http/contracts";

export type { BudgetImportPreview, BudgetImportRequest, BudgetImportResult };

/** 固定当前核价版本，读取覆盖确认所需状态。 */
export async function previewBudgetConfirmationImport(itineraryId: string, budgetId: string): Promise<BudgetImportPreview> {
  const { data } = await httpClient.get<ApiEnvelope<BudgetImportPreview>>(`/fulfillment-orders/itineraries/${encodeURIComponent(itineraryId)}/budget-import-preview`, { params: { budget_order_id: budgetId } });
  if (data.code !== "OK" || !data.data) throw new Error("导入预检失败");
  return data.data;
}

/** 写入固定来源与目标修订；调用方在不确定结果重试时复用请求标识。 */
export async function importBudgetConfirmation(itineraryId: string, body: BudgetImportRequest): Promise<BudgetImportResult> {
  const { data } = await httpClient.post<ApiEnvelope<BudgetImportResult>>(`/fulfillment-orders/itineraries/${encodeURIComponent(itineraryId)}/import-budget`, body, { timeout: 120_000, "axios-retry": { retries: 0 } });
  if (data.code !== "OK" || !data.data) throw new Error("核价导入失败");
  return data.data;
}
